<template>
  <van-tabbar class="custom-tabbar" v-model="active" route fixed active-color="#807dfc" inactive-color="#888">
    <van-tabbar-item name="home" icon="home-o" to="/h5/home">首页</van-tabbar-item>
    <van-tabbar-item name="my" icon="user-circle-o" to="/h5/my">我的</van-tabbar-item>
  </van-tabbar>
</template>

<script>
const TAB_MAP = [
  { name: "home", match: (path) => path.startsWith("/h5/home") },
  { name: "my", match: (path) => path.startsWith("/h5/my") },
];

export default {
  name: "H5TabBar",
  data() {
    return {
      active: "home",
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        const tab =
          TAB_MAP.find((item) => item.match(route.path || "")) || TAB_MAP[0];
        this.active = tab.name;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-tabbar {

  border-top: 1px solid #f0f0f0;
  z-index: 1000;
}
</style>
